import { useState } from 'react'
import { BoardingPassengers } from '../../BoardingPassengers'
import { CabinSafetyCheck } from '../CabinSafetyCheck'
import { Departure } from '../Departure'
import { useWaypointInfo } from './useWaypointInfo'
import type { AdVehicleStreamWaypointAttendanceActionCardVehicleFragment } from './WaypointAttendanceActionCard.hook'

export const WaypointAttendanceActionCard = ({
  vehicle,
}: {
  vehicle: AdVehicleStreamWaypointAttendanceActionCardVehicleFragment
}) => {
  const [isCabinSafetyConfirmed, setIsCabinSafetyConfirmed] = useState(false)
  const { waypoint, activeStep, expectedPassengerCount } = useWaypointInfo(
    vehicle.id,
    isCabinSafetyConfirmed,
  )

  return (
    <>
      {activeStep === 'BOARDING' && waypoint && (
        <BoardingPassengers waypoint={waypoint} vehicleId={vehicle.id} />
      )}
      {activeStep === 'CABIN_SAFETY_CHECK' && (
        <CabinSafetyCheck
          vehicle={vehicle}
          onSuccess={() => setIsCabinSafetyConfirmed(true)}
          expectedPassengerCount={expectedPassengerCount}
        />
      )}
      {activeStep === 'DEPARTURE' && <Departure />}
    </>
  )
}
